// language=GraphQL
export const ALL_PASSPORTS_DATA_QUERY = `query Query {
  passportsData: passportsData {
    id
    type
    number
    birthPlace
    issuePlace
    issueDate
    validUntil
  }
}`

// language=GraphQL
export const SINGLE_PASSPORT_DATA_QUERY = `query Query($id: ID!) {
  passportData: passportData(id: $id) {
    id
    type
    number
    birthPlace
    issuePlace
    issueDate
    validUntil
  }
}`

// language=GraphQL
export const CREATE_PASSPORT_DATA_MUTATION = `
  mutation Mutation($input: CreatePassportDataInput) {
    passportData: createPassportData(input: $input) {
      id
      type
      number
      birthPlace
      issuePlace
      issueDate
      validUntil
    }
  }`

// language=GraphQL
export const UPDATE_PASSPORT_DATA_MUTATION = `
  mutation Mutation($input: UpdatePassportDataInput) {
    passportData: updatePassportData(input: $input) {
      id
      type
      number
      birthPlace
      issuePlace
      issueDate
      validUntil
    }
  }`

// language=GraphQL
export const DELETE_PASSPORT_DATA_MUTATION = `
  mutation Mutation($input: DeletePassportDataInput) {
    deletePassportData(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_PASSPORT_DATA_MUTATION = `
  mutation Mutation($input: DeletePassportDataInput) {
    forceDeletePassportData(input: $input) {
      success
    }
  }`
// language=GraphQL
export const PASSPORTS_DATA_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravellers: Boolean = false) {
  groupedDependents: passportDataDependents(id: $id) {
    travellers @include(if: $withTravellers) {
      id
      salutation
      firstName
      lastName
      birthday
      nationality
      email
      phone
      address
      addressNumber
      addressAddition
      zip
      city
      country
    }
  }
}`
